module.exports = __webpack_public_path__ + "static/gm-41-d9ad82e23dd12e635ce70bf886140d23.jpg";